__turbopack_context__.v({
  "chevronWrap": "PreferenceCenter-module-scss-module__kTP55q__chevronWrap",
  "flexBetweenRow": "PreferenceCenter-module-scss-module__kTP55q__flexBetweenRow",
  "flexGrowText": "PreferenceCenter-module-scss-module__kTP55q__flexGrowText",
  "fullWidth": "PreferenceCenter-module-scss-module__kTP55q__fullWidth",
});
